export const parseCurrencyValue = value => {
  if (value == null || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  const cleaned = String(value)
    .trim()
    .replace(/[^\d,.-]/g, "");
  const normalized =
    cleaned.includes(",") && cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")
      ? cleaned.replace(/\./g, "").replace(",", ".")
      : cleaned.replace(/,/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatCurrency = value => {
  const parsed = parseCurrencyValue(value);

  return parsed != null
    ? parsed.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : "--";
};
